import React, { useState, useRef, useEffect } from 'react';
import {useHistory, useLocation} from 'react-router-dom';
// @redux
import {connect, useSelector} from 'react-redux';
import Iframe from 'react-iframe';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Card, CardContent, TextField, Button } from '@material-ui/core';
import clsx from 'clsx';
import Markdown from 'react-markdown';
import axios from 'axios';  
import { v4 as uuid } from 'uuid';
import Chat from './components/Chat';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        width: '100%',
    },
    iframe: {
        border: '0px',
        height: '100vh',
        width: '100%',
    }
}));

const AssistantTALIBK = () => {   
    const classes = useStyles();
    const [sessionId, setSessionId] = useState(uuid());
    const [comment, setComment] = useState('');
    const [current_session_title, setCurrent_session_title] = useState('');
    const [conversation, setConversation] = useState([]);
    const user = useSelector((state) => state.userReducer.user);
    const messagesEndRef = useRef(null);

    // Función para hacer scroll automático al final
    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Efecto para hacer scroll cuando cambie el historial
    // useEffect(() => {
    //     scrollToBottom();
    // }, [history]);

    // ¿Por qué la respuesta del assistant y el error ponen el +2 en el order?
    // El +2 se usaba porque history.length no se actualiza inmediatamente tras setHistory (por el mensaje del usuario).
    // Pero esto puede causar problemas si hay concurrencia o si el estado no se actualiza como se espera.
    // Lo correcto es calcular el order en función del último mensaje en el historial, o usar una función de actualización.

    const handleService = async () => {
        if (!comment.trim()) return;

        const currentComment = comment;
        setComment('');

        // Agregar mensaje del usuario al historial solo una vez
        const userMessage = {
            role: 'user',
            content: currentComment,
            order: conversation.length + 1,
            session_id: sessionId,
            session_name: current_session_title,
        };
        setConversation(prev => [...prev, userMessage]);
        
        // Scroll inmediato después de agregar el mensaje del usuario
        setTimeout(() => scrollToBottom(), 100);

        const URL = 'https://iprgg9g54g.execute-api.us-east-1.amazonaws.com/prod/message';
        try {
            const response = await axios.post(
                URL,
                {
                    "message": currentComment,
                    "session_id": sessionId,
                    "user_id": user.person_id.toString(), // TODO: tiene que ser en funcion de cuanod inicia un chat con el assistant
                    "agent_type": "openai",
                    "session_name": current_session_title,
                },
                {
                    headers: { 'x-api-key': '7KP9CUmnZW4dbg2dTZHaE3S3WIOaA8rF7yRPhhn9' }
                }
            );
            if(response.data.session_name){    
                setCurrent_session_title(response.data.session_name);
            }
            // Para asegurar el orden correcto, usamos una función de actualización
            setConversation(prev => {
                const lastOrder = prev.length > 0 ? prev[prev.length - 1].order : 0;
                const assistantMessage = {
                    role: 'assistant',
                    content: response.data.response,
                    order: lastOrder + 1,
                    session_id: sessionId,
                    session_name: current_session_title,
                };
                return [...prev, assistantMessage];
            });
        } catch (error) {
            setConversation(prev => {
                const lastOrder = prev.length > 0 ? prev[prev.length - 1].order : 0;
                const errorMessage = {
                    role: 'assistant',
                    content: "Ocurrió un error al obtener la respuesta.",
                    order: lastOrder + 1,
                    session_id: sessionId,
                    session_name: current_session_title,
                };
                return [...prev, errorMessage];
            });
            console.error(error);
        }
    }
    return (
        <Box className={classes.root}>
            <Typography variant="h1" className={'mb-4'}>Asistente TALI</Typography>
            {/* <Iframe width="100%" className={classes.iframe} height="100%" scrolling="yes" overflow="hidden" frameBorder="0" src="https://talisis.ai-studio.mx" /> */}
            <Box
                // className={classes.card}
            >
                    <Chat 
                        handleSentMessage={handleService} 
                        title={current_session_title} 
                        conversation={conversation}
                        comment={comment}
                        setComment={setComment}
                    />
            </Box>
        </Box>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AssistantTALIBK);